import React, { useEffect } from "react";

const LogoutSync = () => {
  useEffect(() => {
    localStorage.removeItem("token");

    const params = new URLSearchParams(window.location.search);
    const redirectBack = params.get("redirectBack") || "/login";

    setTimeout(() => {
      window.location.href = redirectBack;
    }, 200);
  }, []);

  return (
     <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.5rem",
        fontWeight: "bold",
      }}
    >
      Logging out...
    </div>
  );

};

export default LogoutSync;
